import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import "antd/es/select/style";
import _Select from "antd/es/select";
var _excluded = ["optionItemRender", "mode", "onSearch", "onFocus", "onChange", "autoClearSearchValue", "searchOnFocus", "resetAfterSelect", "optionFilterProp", "optionLabelProp", "className", "disabled", "options", "fetchData", "resetData", "prefixCls", "onClear", "searchValue", "showSearch"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useImperativeHandle, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
var Option = _Select.Option,
    OptGroup = _Select.OptGroup;

var SearchSelect = function SearchSelect(props, ref) {
  var optionItemRender = props.optionItemRender,
      mode = props.mode,
      onSearch = props.onSearch,
      _onFocus = props.onFocus,
      _onChange = props.onChange,
      autoClearSearchValue = props.autoClearSearchValue,
      _props$searchOnFocus = props.searchOnFocus,
      searchOnFocus = _props$searchOnFocus === void 0 ? false : _props$searchOnFocus,
      _props$resetAfterSele = props.resetAfterSelect,
      resetAfterSelect = _props$resetAfterSele === void 0 ? false : _props$resetAfterSele,
      _props$optionFilterPr = props.optionFilterProp,
      optionFilterProp = _props$optionFilterPr === void 0 ? 'label' : _props$optionFilterPr,
      _props$optionLabelPro = props.optionLabelProp,
      optionLabelProp = _props$optionLabelPro === void 0 ? 'label' : _props$optionLabelPro,
      className = props.className,
      disabled = props.disabled,
      options = props.options,
      fetchData = props.fetchData,
      resetData = props.resetData,
      customizePrefixCls = props.prefixCls,
      _onClear = props.onClear,
      propsSearchValue = props.searchValue,
      showSearch = props.showSearch,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(propsSearchValue),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var selectRef = useRef();
  useImperativeHandle(ref, function () {
    return selectRef.current;
  });
  useEffect(function () {
    if (restProps.autoFocus) {
      var _selectRef$current;

      selectRef === null || selectRef === void 0 ? void 0 : (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.focus();
    }
  }, [restProps.autoFocus]);
  useEffect(function () {
    setSearchValue(propsSearchValue);
  }, [propsSearchValue]);

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-filed-search-select', customizePrefixCls); // 兼容 renderXXX API。

  var classString = classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled));

  var getMergeValue = function getMergeValue(value, option) {
    if (Array.isArray(value) && value.length > 0) {
      // 多选情况且用户有选择
      return value.map(function (item, index) {
        var optionItem = option === null || option === void 0 ? void 0 : option[index];
        var dataItem = (optionItem === null || optionItem === void 0 ? void 0 : optionItem['data-item']) || {};
        return _objectSpread(_objectSpread({}, dataItem), item);
      });
    }

    return [];
  };

  var renderOptions = function renderOptions(mapOptions) {
    return mapOptions.map(function (item) {
      var label = item.label,
          value = item.value,
          itemDisable = item.disabled,
          itemClassName = item.className,
          optionType = item.optionType;

      if (optionType === 'optGroup') {
        return /*#__PURE__*/React.createElement(OptGroup, {
          key: item.key || item.value,
          label: item.label
        }, renderOptions((item === null || item === void 0 ? void 0 : item.options) || (item === null || item === void 0 ? void 0 : item.children) || []));
      }

      return /*#__PURE__*/React.createElement(Option, _extends({}, item, {
        value: value,
        key: value || (label === null || label === void 0 ? void 0 : label.toString()),
        disabled: itemDisable,
        "data-item": item,
        className: "".concat(prefixCls, "-option ").concat(itemClassName || ''),
        label: item.label
      }), (optionItemRender === null || optionItemRender === void 0 ? void 0 : optionItemRender(item)) || label);
    });
  };

  return /*#__PURE__*/React.createElement(_Select, _extends({
    ref: selectRef,
    className: classString,
    allowClear: true,
    disabled: disabled,
    mode: mode,
    showSearch: showSearch,
    searchValue: searchValue,
    optionFilterProp: optionFilterProp,
    optionLabelProp: optionLabelProp,
    onClear: function onClear() {
      _onClear === null || _onClear === void 0 ? void 0 : _onClear();
      fetchData('');

      if (showSearch) {
        setSearchValue('');
      }
    }
  }, restProps, {
    onSearch: showSearch ? function (value) {
      fetchData(value);
      onSearch === null || onSearch === void 0 ? void 0 : onSearch(value);
      setSearchValue(value);
    } : undefined,
    onChange: function onChange(value, optionList) {
      // 将搜索框置空 和 antd 行为保持一致
      if (showSearch && autoClearSearchValue) {
        fetchData('');
        onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
        setSearchValue('');
      }

      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      if (!props.labelInValue) {
        _onChange === null || _onChange === void 0 ? void 0 : _onChange.apply(void 0, [value, optionList].concat(rest));
        return;
      }

      if (mode !== 'multiple') {
        // 单选情况且用户选择了选项
        var dataItem = optionList && optionList['data-item'] || {};
        _onChange === null || _onChange === void 0 ? void 0 : _onChange.apply(void 0, [_objectSpread(_objectSpread({}, value), dataItem), optionList].concat(rest));
        return;
      } // 合并值


      var mergeValue = getMergeValue(value, optionList);
      _onChange === null || _onChange === void 0 ? void 0 : _onChange.apply(void 0, [mergeValue, optionList].concat(rest)); // 将搜索结果置空，重新搜索

      if (resetAfterSelect) resetData();
    },
    onFocus: function onFocus(e) {
      if (searchOnFocus) {
        fetchData('');
      }

      _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(e);
    }
  }), renderOptions(options || []));
};

export default /*#__PURE__*/React.forwardRef(SearchSelect);